import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles } from '@/js/libs/use-auth';

import RouteParamsValidator from 'src/components/RouteParamsValidator.tsx';
import { validatePostCampaignStatus } from 'src/scenes/PostCampaign/helpers.ts';
import PostCampaign from 'src/scenes/PostCampaign/index.ts';
import Status from 'src/scenes/Status/index.ts';

const index = true;

export const ordersPostCampaignsRouteObject = inferRouteObject({
  path: 'orders/post-campaigns',
  element: <PrivateRoute roles={Roles.POSTADMANAGER} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: PostCampaign.Helmet,
      children: [
        { index, Component: PostCampaign.CampaignsList },
        {
          path: ':status',
          element: <RouteParamsValidator validate={validatePostCampaignStatus} invalidStateElement={<Status.NotFound />} />,
          children: [
            {
              index,
              element: <Navigate to='/orders/post-campaigns' replace />,
            },
            {
              element: <PostCampaign.Providers />,
              children: [
                {
                  element: <PostCampaign.ListAndOverviewProviders />,
                  children: [
                    {
                      path: ':campaignId',
                      children: [
                        { index, Component: PostCampaign.Overview },
                        { path: 'history', Component: PostCampaign.History },
                      ],
                    },
                  ],
                },
                {
                  element: <PostCampaign.BookingToolProviders />,
                  children: [
                    { path: 'new-order/:accountId?', Component: PostCampaign.Edit },
                    {
                      path: ':campaignId',
                      children: [
                        { path: 'edit', Component: PostCampaign.Edit },
                        { path: 'information/:informationId?', Component: PostCampaign.Information },
                        { path: 'target-group-settings/:targetGroupId?', Component: PostCampaign.TargetGroupSettings },
                        { path: 'calculation', Component: PostCampaign.Calculation },
                        { path: 'edit-positions/:positionType?', Component: PostCampaign.EditPositions },
                        { path: 'document-preview', Component: PostCampaign.DocumentPreview },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});
